import { useState } from "react";

/** Copy text to the clipboard; `copied` stays true briefly after a copy. */
export function useCopy(): { copied: boolean; copy: (text: string) => Promise<void> } {
  const [copied, setCopied] = useState(false);
  async function copy(text: string) {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      // Clipboard blocked: the text stays visible and selectable.
    }
  }
  return { copied, copy };
}
